import { MdOutlineShowChart, MdSensors, MdOutlineAssignment } from "react-icons/md"
import { IoWarningOutline } from "react-icons/io5"
import { GiCoalWagon, GiHole, GiRoad } from "react-icons/gi"
import { BsCardChecklist, BsSignpost2 } from "react-icons/bs"
import { AiOutlinePoundCircle } from "react-icons/ai"
import { VscSettingsGear } from "react-icons/vsc"
import { FiUsers, FiMonitor } from "react-icons/fi"
import { CgBorderStyleSolid, CgBorderStyleDotted } from "react-icons/cg"
import classNames from "classnames"

type Props = { menuItemName: string; primeIconsClassName?: string }

const MenuItemIcon = ({ menuItemName, primeIconsClassName, ...rest }: Props) => {
  switch (menuItemName) {
    case "Live Wagons":
      return <GiCoalWagon {...rest} />
    case "Live":
    case "Sensor Data":
    case "Devices":
      return <MdSensors {...rest} />
    case "Network Overview":
      return <FiMonitor {...rest} strokeWidth={1.5} />
    case "Detections":
      if (primeIconsClassName === "dashboard") return <FiMonitor {...rest} strokeWidth={1.5} />
      return <i className={classNames(primeIconsClassName)} {...rest} />
    case "Route View":
    case "PMTiles Route View":
    case "Old Route View":
      return <GiRoad {...rest} />
    case "Repairs":
      return <BsCardChecklist {...rest} />
    case "Surface Defects":
      return <GiHole {...rest} />
    case "Defect Cost Analysis":
      return <AiOutlinePoundCircle {...rest} />
    case "Surface Cracking":
      return <MdOutlineShowChart {...rest} />
    case "Line Overview":
      return <CgBorderStyleSolid {...rest} />
    case "Faded Lines":
      return <CgBorderStyleDotted {...rest} />
    case "Signs":
      return <BsSignpost2 {...rest} />
    case "Signage Defects":
      return <IoWarningOutline {...rest} />
    case "Users":
      return <FiUsers {...rest} />
    case "Settings":
      return <VscSettingsGear {...rest} />
    case "Action Logging":
      return (
        <i
          className={classNames(primeIconsClassName)}
          {...rest}
          style={{ marginRight: 10, marginLeft: 4 }}
        />
      )
    // default case uses the primeicons string passed from the menu template (if any)
    default:
      return <i className={classNames(primeIconsClassName)} {...rest} />
  }
}

export default MenuItemIcon
